import React from 'react';
import './Nav.css';
import Resume from './AnumMujahidResume.pdf';
function Nav() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-none" style={{borderBottom: '1px solid rgba(0,0,0,0.05)'}}>
      <div className="container">
        <a className="navbar-brand" href="/">
          <i className="fab fa-amilia nav__logo">num</i>
          <div className="nav__logocircle"></div>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ml-auto text-center">
            <li className="nav-item ml-3">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>
            <li className="nav-item ml-3">
              <a className="nav-link" href="#experience">
                Experience
              </a>
            </li>
            <li className="nav-item ml-3">
              <a className="nav-link" href="#projects">
                Projects
              </a>
            </li>
            <li className="nav-item ml-3">
              <a className="nav-link" href="#contacts">
                Contact
              </a>
            </li>
            <li className="nav-item ml-3">
              <a
                className="nav-link"
                href={Resume}
                download="Resume"
                tabIndex="-1"
                aria-disabled="true"
              >
                Resume
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
